import { AbilityBuilder } from '@casl/ability';

export const defineAbilitiesFor = (rolePermissions) => {
    const { can, rules } = new AbilityBuilder();

    rolePermissions.forEach(({ key, can_add, can_edit, can_view, can_delete }) => {
        if (can_view) can('read', key);
        if (can_add) can('create', key);
        if (can_edit) can('update', key);
        if (can_delete) can('delete', key);
    });

    return rules;
};
